export function identifyGhostBookings<T>(
  bookings: T[],
  getBookingId: (b: T) => string,
  getGroupId: (b: T) => string | null,
  activeGroupIds: Set<string>,
  options?: {
    onlyCheckGroupIds?: string[];
  }
): { sanitizedBookings: T[]; ghostBookingIds: string[] } {
  const ghostBookingIds: string[] = [];
  const sanitizedBookings: T[] = [];
  const onlyCheckSet = options?.onlyCheckGroupIds
    ? new Set(options.onlyCheckGroupIds)
    : null;

  for (const booking of bookings) {
    const groupId = getGroupId(booking);
    // Only check if it's a candidate for being a ghost (it's in a group, and if we're only checking specific groups, it's one of them)
    const isCheckCandidate =
      groupId && (!onlyCheckSet || onlyCheckSet.has(groupId));

    if (isCheckCandidate && !activeGroupIds.has(groupId!)) {
      ghostBookingIds.push(getBookingId(booking));
    } else {
      sanitizedBookings.push(booking);
    }
  }

  return { sanitizedBookings, ghostBookingIds };
}
